module.exports = __webpack_public_path__ + "img/banner3.69be1805.jpg";